import { useEffect } from "react";
import { BookReview } from "types/api";

export const bookReducer = (
  state: BookReview | null,
  action: {
    type: string;
    book?: Pick<BookReview, "bookshopIsbn" | "asin" | "title">;
  }
) => {
  switch (action.type) {
    case "toggle":
      return state === action.book ? null : action.book;
    case "close-all":
      return null;
  }
};

export const useEscape = (
  dispatch: React.Dispatch<{
    type: string;
    book?: Pick<BookReview, "bookshopIsbn" | "asin" | "title"> | undefined;
  }>
) => {
  useEffect(() => {
    const close = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        dispatch({ type: "close-all" });
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [dispatch]);
};
